__turbopack_context__.v({
  "boxSize": "styles-module-scss-module__Xj2T8a__boxSize",
  "commonMargins": "styles-module-scss-module__Xj2T8a__commonMargins",
  "consent": "styles-module-scss-module__Xj2T8a__consent",
  "countryCodeContainer": "styles-module-scss-module__Xj2T8a__countryCodeContainer",
  "error": "styles-module-scss-module__Xj2T8a__error",
  "errorMessage": "styles-module-scss-module__Xj2T8a__errorMessage",
  "label": "styles-module-scss-module__Xj2T8a__label",
  "nameContainer": "styles-module-scss-module__Xj2T8a__nameContainer",
  "selectInput": "styles-module-scss-module__Xj2T8a__selectInput",
  "successMessage": "styles-module-scss-module__Xj2T8a__successMessage",
});
